"use client";

import { logEvent } from "@/services/firebase";

export const MapLocation = () => {
  return (
    <div
      className="mapouter relative text-right w-full h-60"
      onClick={() => logEvent("map_location_click")}
    >
      <div className="gmap_canvas w-full h-60 overflow-hidden bg-transparent">
        <iframe
          title="Google Maps"
          className="gmap_iframe w-full h-60"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.6203083417113!2d-46.642865178230885!3d-23.617946408728084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4e77f74df345ca1d%3A0xbaf5817774422c3a!2zRG9teW5pcXVlIE1vdGEgfCBOdXRyacOnw6NvIGUgU2HDumRl!5e0!3m2!1spt-BR!2sbr!4v1744067046110!5m2!1spt-BR!2sbr"
        ></iframe>
      </div>
    </div>
  );
};
